export default __webpack_public_path__ + "static/media/chevron-left.0cdf57b8.svg";